import { yupResolver } from "@hookform/resolvers/yup";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { t } from "i18next";
import { useForm } from "react-hook-form";
import { Button } from "ui";

import { infoBarDataSchema } from "../../../helpers";
import { InfoBarDataFormColumn } from "./atoms";
import {
  InfoBarDataFormProps,
  InfoBarDataFormValues
} from "./InfoBarDataForm.types";

import styles from "./InfoBarDataForm.module.scss";

const InfoBarDataForm = ({
  formId,
  defaultValues,
  onSubmit,
  isLoadingUpdate
}: InfoBarDataFormProps) => {
  const {
    handleSubmit,
    control,
    reset,
    formState: { isDirty }
  } = useForm<InfoBarDataFormValues>({
    defaultValues,
    resolver: yupResolver(infoBarDataSchema)
  });

  const onCancel = () => {
    reset();
  };

  return (
    <form id={formId} className={styles.form} onSubmit={handleSubmit(onSubmit)}>
      <div className={styles.form_columnsWrapper}>
        <InfoBarDataFormColumn control={control} columnType="shippingData" />
        <InfoBarDataFormColumn control={control} columnType="returnsData" />
      </div>

      <div className={styles.form_divider} />
      <div className={styles.form_buttons}>
        <Button type="button" variant="default" block onClick={onCancel}>
          {t("Cancel")}
        </Button>
        <Button
          type="submit"
          form={formId}
          variant={"primary"}
          loading={isLoadingUpdate}
          block
          onClick={undefined}
          disabled={!isDirty}
        >
          {t("Save")}
        </Button>
      </div>
    </form>
  );
};

export default InfoBarDataForm;
